import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { DuplicateProformaInvoice } from "@src/components/modules/invoices/Create/modules/DuplicateProformaInvoice";
import { NavigationProformaInvoice } from "@src/components/widgets/AppSubNav/navigation-invoices/proforma-invoices";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Duplicate proforma`}
    navigation={<NavigationProformaInvoice invoiceId={id} />}
  >
    <DuplicateProformaInvoice id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/invoices/proforma-invoices/duplicate")({
  component: RouteComponent,
});
